import React from 'react'

const MainFooter = () => {
  const isOurRates = window.location.href.includes('our-rates')
  const isCalculator = window.location.href.includes('calculators')
  const currentYear = new Date().getFullYear();

  return (
    <div className="yard-footer-wrapper">
      <footer className="yard-footer">
        <div className="yard-footer__grid">
          <div className="yard-footer__logo-and-social">
            <div className="yard-logo-container">
              <a href="/" className="yard-logo-container">
                <img
                  src={gon.assets.yardLogoFooter}
                  className="yard-footer__logo"
                  alt="Yard logo"
                />
                <p className="green text-under-logo">
                  Helping Australians build wealth through residential property
                </p>
              </a>
            </div>
            <div className="yard-social-container">
              <div className="row">
                <div className="yard-footer__address">
                  <img
                    src={gon.assets.mapPin}
                    className="social-logo"
                    alt="map pin"
                  />
                </div>
                <div className="yard-footer-address">
                  Level 17, 300 Barangaroo Avenue, Sydney NSW 2000
                </div>
              </div>
              <div className="yard-footer__social-links">
                <a
                  href="https://www.facebook.com/Yard.Australia/?modal=admin_todo_tour"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="social-square">
                    <img
                      src={gon.assets.facebook}
                      className="social-logo"
                      alt="facebook logo"
                    />
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/yard_au/"
                  target="_blank"
                  rel="noopener nofollow"
                >
                  <div className="social-square">
                    <img
                      src={gon.assets.instagram}
                      className="social-logo"
                      alt="instagram logo"
                    />
                  </div>
                </a>
                <a
                  href="https://www.linkedin.com/company/yard-au/about/"
                  target="_blank"
                  rel="noopener nofollow"
                >
                  <div className="social-square">
                    <img
                      src={gon.assets.linkedin}
                      className="social-logo"
                      alt="linkedin logo"
                    />
                  </div>
                </a>
                <a
                  href="https://twitter.com/Yard_AU"
                  target="_blank"
                  rel="noopener nofollow"
                >
                  <div className="social-square">
                    <img
                      src={gon.assets.twitter}
                      className="social-logo"
                      alt="twitter logo"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="yard-footer__col-wrapper">
            <div className="yard-footer__link-column">
              <h4 className="yard-footer__link-column-title">Home loans</h4>
              <ul className="yard-footer__link-column-links">
                <li>
                  <a href="/loans">Home / Investor loan</a>
                </li>
                <li>
                  <a href="/loans/construction-loan">Construction loan</a>
                </li>
                <li>
                  <a href="/loans/bridging-loan">Bridging loan</a>
                </li>
                <li>
                  <a href="/loans/smsf-loan">SMSF loan</a>
                </li>
                <li>
                  <a href="/loans/alt-doc-home-loan">Low doc loan</a>
                </li>
                <li>
                  <a href="/loans/self-employed-home-loan">
                    Self employed loan
                  </a>
                </li>
                <li>
                  <a href="/loans/ndis-property-loan">
                    NDIS loan
                  </a>
                </li>
              </ul>
            </div>
            <div className="yard-footer__link-column">
              <h4 className="yard-footer__link-column-title">
                Commercial loans
              </h4>
              <ul className="yard-footer__link-column-links">
                <li>
                  <a href="https://www.yard.com.au/loans/commercial-property-loan/low-rate">
                    Low rate loan
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/commercial-property-loan/low-doc">
                    Low doc loan
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/smsf-loan">
                    Commercial SMSF loan
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/commercial-property-loan/lease-doc">
                    Lease doc loan
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/developer-finance/property-development-finance">
                    Development finance
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/business-vehicle-leasing">
                    Business car lease
                  </a>
                </li>
              </ul>
            </div>
            <div className="yard-footer__link-column">
              <h4 className="yard-footer__link-column-title">
                Investments
              </h4>
              <ul className="yard-footer__link-column-links">
                <li>
                  <a href="https://www.yard.com.au/loans/invest">
                    Income trust  
                  </a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/loans/invest/getting-started">
                    How to invest
                  </a>
                </li>
              </ul>
            </div>
            <div className="yard-footer__link-column">
              <h4 className="yard-footer__link-column-title">Resources</h4>
              <ul className="yard-footer__link-column-links">
                <li>
                  <a href="/pages/our-rates">Our rates</a>
                </li>
                <li>
                  <a href="/pages/how-to-apply">How to apply</a>
                </li>
                <li>
                  <a href="/calculators">Calculators</a>
                </li>
                <li>
                  <a href="/pages/faq">FAQ</a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/resources">Blog</a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/resources/sitemap">Sitemap</a>
                </li>
              </ul>
            </div>
            <div className="yard-footer__link-column">
              <h4 className="yard-footer__link-column-title">Company</h4>
              <ul className="yard-footer__link-column-links">
                <li>
                  <a href="/pages/contact-us">Contact us</a>
                </li>
                <li>
                  <a href="/pages/about">About us</a>
                </li>
                <li>
                  <a href="https://www.yard.com.au/resources/careers">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="/pages/privacy">Privacy</a>
                </li>
                <li>
                  <a href="/pages/credit-guide">Credit guide</a>
                </li>
                <li>
                  <a href="/pages/credit-reporting">Credit reporting</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="black smaller d-sm-block disclaimer">
          {isCalculator && (
            <div class="smaller d-sm-block disclaimer mb-3">
              <div class="calculators-disclaimer-info">
                <h5 class="calculators-disclaimer-info__title">
                  Important information about our Calculators
                </h5>
                <p>
                  These calculators provide an estimated guide. The calculations
                  are not a loan approval. All loan applications are subject to
                  Yard’s eligibility criteria and credit approval. Terms and
                  conditions will apply to the loan. Please note the
                  calculations:
                </p>
                <ul class="calculators-disclaimer-info__list">
                  <li>
                    Do not take into account fees, charges or other amounts that
                    may be charged to your loan (such as establishment or
                    monthly service fees or stamp duty);
                  </li>
                  <li>
                    Do not include Lenders Mortgage Insurance, if payable;
                  </li>
                  <li>
                    Do not consider the security or loan attributes that may
                    apply to you;
                  </li>
                  <li>
                    Interest rates referenced are current rates and may change
                    at any time;
                  </li>
                  <li>
                    Do not cover the different rates that may apply, depending
                    on whether you are making interest only payments or
                    principal and interest repayments (for e.g. during an
                    interest only period, your interest only payments won't
                    reduce your loan balance and at the end of an interest only
                    period, your repayments will increase to cover the principal
                    and interest payment); or
                  </li>
                  <li>
                    Do not take into consideration interest rate changes that
                    may occur during the life of your loan.
                  </li>
                </ul>
                <p>
                  Any of these additional amounts may increase repayments under
                  the loan. You should seek independent, professional advice
                  before making any decision based on this information. This
                  calculator stores your calculation as a cookie. Clear your
                  calculation to start again.
                </p>
                <p>
                  <a href="../calculators/key-facts">
                    Key Fact Sheet for Home Loans
                  </a>
                </p>
              </div>
            </div>
          )}
          {isOurRates && (
            <p>
              ^If you add an offset account, your comparison rate will change.
            </p>
          )}
          <p>
            Yard Financial Pty Ltd | ACN 623 357 513 | Australian Credit Licence
            509481. Yard Home Loans Pty Ltd | ACN 634 101 901 | Credit
            Representative Number 517113 and Yard Broker Pty Ltd | ACN 660 832
            324 | Credit Representative Number 541605 for Yard Financial Pty Ltd
            ACN 623 357 513 Australian Credit Licence 509481.
          </p>
          <p>
            Interest rates apply to new loan applications on or after 9 October
            2026. The interest rates are subject to change at any time. Terms,
            conditions and eligibility criteria apply to all our loan products
            and features. Fees, charges and disbursements are payable. Final
            approval is subject to credit assessment.
          </p>
          <p>
            The comparison rate is based on a loan amount of $150,000, over a
            25-year term. For variable interest only loans, comparison rates are
            based on an initial 5-year interest only period. During an interest
            only period, your interest only repayments will not reduce your loan
            balance. This may mean you pay more interest over the life of the
            loan. <span className="disclaimer-warning">WARNING:</span> This
            comparison rate applies only to the example or examples given.
            Different amounts and terms will result in different comparison
            rates. Costs such as redraw fees or early repayment fees, and cost
            savings such as fee waivers, are not included in the comparison rate
            but may influence the cost of the loan. Terms, conditions, fees and
            charges apply, and your full financial situation would need to be
            reviewed prior to acceptance of any Yard offer or product.
          </p>
          <p>
            Yard Asset Management Pty Ltd ACN 678 090 723 (Yard Asset) is a
            corporate authorised representative (CAR) (CAR Number 1311859) of
            Yard Financial Pty Ltd ACN 623 357 513 AFSL 509481.
          </p>
          <p>
            Any information or advice is general advice only and has been
            prepared by Yard Asset for individuals identified as wholesale
            investors for the purposes of providing a financial product or
            financial service, under Section 761G or Section 761GA of the
            Corporations Act 2001 (Cth). Any information or advice given does
            not take into account your particular objectives, financial
            situation or needs and before acting on the advice, you should
            consider the appropriateness of the advice, having regard to your
            objectives, financial situation and needs. If any advice relates to
            the acquisition, or possible acquisition, of a particular financial
            product you should read any relevant Product Disclosure Statement or
            like instrument.
          </p>
          <p>
            © {currentYear} Yard is a registered trademark of Yard Financial Pty Ltd
            (ABN: 84 623 357 513). All rights reserved. This website is operated
            by Yard subject to the{" "}
            <a href="/pages/terms">Website Terms & Conditions</a>.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default MainFooter;
